<template>
    <tag limit-width="500" v-bind="$attrs">
        <component
            :is="icon"
            class="h-4 w-6 mx-1 text-primary"/>
        <div class="flex items-center">
            <div
                :class="{ 'truncate': firstItem && $parent.$el && $parent.$el.clientWidth }"
                :style="setStyle()"
            >
                {{ name }}
            </div>
            <i v-if="showDeleteButton" class="mx-1 vc-icon-close text-xs cursor-pointer" @click="deleteItem" />
        </div>
    </tag>
</template>
<script>
   
    export default {
        components: {
            Tag: () => import('@/modules/reports/components/Tag')
        },
        props: {
            name: String,
            icon: String,
            item: [Object, String],
            showDeleteButton: {
                type: Boolean,
                default: false
            },
            firstItem: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            deleteItem () {
                this.$emit('delete', this.item)
            },
            setStyle () {
                if (!this.firstItem || !this.$parent.$el || !this.$parent.$el.clientWidth) {
                    return
                }
                const columnWidth = this.$parent.$el.clientWidth - 110

                return {
                    'maxWidth': `${columnWidth}px`
                }
            }
        }
    }
</script>
